<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // Set initial language
    this.updateDocumentLang();
  },
  watch: {
    '$i18n.locale'() {
      // Update document lang when language changes
      this.updateDocumentLang();
    }
  },
  methods: {
    updateDocumentLang() {
      document.documentElement.lang = this.$i18n.locale;
    }
  }
}
</script>

<style lang="scss">
.v-application {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

